export default __webpack_public_path__ + "static/media/call-logs-empty.e4d3dad0.svg";